import { useMutation } from "@tanstack/react-query";
import api, { ApiCatalog } from "@/api";

interface UnpublishStandardsSetProps {
  standardsSetId: string;
}

export const useUnpublishStandardsSet = () => {
  return useMutation<void, Error, UnpublishStandardsSetProps>({
    mutationFn: async ({
      standardsSetId,
    }: UnpublishStandardsSetProps): Promise<void> => {
      await api().delete(
        `${ApiCatalog.draftContent.endpoint}${standardsSetId}/publication/`,
      );
    },
  });
};
